import { createSelector } from 'reselect';
import mapServerSpace from '@src/libs/utils/mapServerSpace';
import getCityUrlDomain from '@src/containers/Session/selectors/getCityDomain';
import getFavourites from '@src/containers/Session/selectors/getFavourites';
import getViewedPoints from '@src/containers/Session/selectors/getViewedPoints';
import { FILTER_CODES } from '@src/containers/Filters/constants';

const getServerItems = (store) => {
	const list = store.Map.fetchSpacesPoints.data?.list || [];
	const entity = store.Map.fetchSpacesPoints.data?.entity || {};

	return list.map((id) => entity[id]);
};

const getActiveId = (store) => store.Map.activeId;

export const getSpacesPoints = createSelector(
	getServerItems,
	getCityUrlDomain,
	getFavourites,
	getActiveId,
	getViewedPoints,
	(items, town, favs, activeId, viewedPoints) => {
		const temp = {};
		const favIds = favs?.spaces.map(({ id }) => id) || [];
		const mapper = mapServerSpace({ favIds, town });

		items
			.filter((v) => !!v && !!v.coordinate)
			.forEach((space) => {
				const coordKey = `${space.coordinate.latitude}${space.coordinate.longitude}`;
				if (temp[coordKey]) {
					temp[coordKey].spaces.push(space);
				} else {
					temp[coordKey] = {
						id: space.id,
						latitude: space.coordinate.latitude,
						longitude: space.coordinate.longitude,
						spaces: [space],
					};
				}
			});

		return Object.keys(temp).map((k) => {
			let pointId = '';
			let markerTitle = t('Нет цены');
			let isFav = false;
			let minPrice = Infinity;

			const mappedSpaces = temp[k].spaces.map((s, i) => {
				const price = s.cardParam.find(
					(a) => a.attribute === FILTER_CODES.PRICE,
				);
				if (price && price.value < minPrice) {
					minPrice = price.value;
					markerTitle = price.text;
				}
				if (!isFav && favs.spaces.some(({ id }) => s.id === id)) {
					isFav = true;
				}

				pointId = `${pointId}_${s.id}_`;

				return mapper(s, i);
			});

			const isActive = pointId.includes(activeId);
			const isVisited = viewedPoints.some((v) => v === pointId);

			return {
				...temp[k],
				id: pointId,
				spaces: mappedSpaces,
				price: markerTitle,
				isFav,
				isActive,
				isVisited,
				isVisitedView: isVisited && !isActive,
				placemarkType: 'pricePoint',
			};
		});
	},
);
